class TourlaneIframeCommunication {
  static postMessage(message) {
    window.postMessage(JSON.stringify(message), window.origin);
  }
}

class TourlaneSuite {
  static showFlexIframe() {
    this.setFlexIframeVisibility(true);
  }

  static hideFlexIframe() {
    this.setFlexIframeVisibility(false);
  }

  static setFlexIframeVisibility(show) {
    const message = {
      action: 'TourlaneSuite: setFlexIframeVisibility',
      show
    };
    TourlaneIframeCommunication.postMessage(message);
  }
}

export { TourlaneSuite, TourlaneIframeCommunication };
